module.exports = __webpack_public_path__ + "static/img/005.c7e14b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/factory/005.jpg
// module id = Jx48
// module chunks = 1